module.exports = __webpack_public_path__ + "static/media/mongodb-logo.e5eee315.png";